var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":_vm.notification.type,"dismissible":""},on:{"dismissed":_vm.dismissedAction}},[_vm._v(_vm._s(_vm.notification.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }